export default "__VITE_ASSET__DAWIRvcn__"